import { io } from 'socket.io-client';

let socket = null;
let currentToken = null;

export function connectSocket(token) {
  if (!token) return null;

  // already connected with the same token
  if (socket && currentToken === token) {
    if (!socket.connected) socket.connect();
    return socket;
  }

  // different token → tear down
  if (socket) {
    try { socket.removeAllListeners(); socket.disconnect(); } catch {}
    socket = null;
  }

  currentToken = token;

  socket = io(import.meta.env.VITE_WS_URL || window.location.origin, {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1500,
    reconnectionDelayMax: 10000,
    timeout: 20000,
    autoConnect: true,
  });

  socket.on('connect', () => console.log('🔌 socket connected'));
  socket.on('disconnect', (r) => console.log('🔌 socket disconnected:', r));
  socket.on('connect_error', (e) => console.warn('🔌 socket error:', e.message));

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (!socket) return;
  try { socket.removeAllListeners(); socket.disconnect(); } catch {}
  socket = null;
  currentToken = null;
}

export default { connectSocket, getSocket, disconnectSocket };